// Home page highlights (6 per season).
import h24a from '../pages/Gallery/Image/Gallery1.webp';
import h24b from '../pages/Gallery/Image/Gallery2.webp';
import h24c from '../pages/Gallery/Image/Gallery3.webp';
import h24d from '../pages/Gallery/Image/Gallery4.webp';
import h24e from '../pages/Gallery/Image/Gallery5.webp';
import h24f from '../pages/Gallery/Image/Gallery6.webp';
import h25a from '../pages/Gallery/Image/Gallery12.webp';
import h25b from '../pages/Gallery/Image/Gallery7.webp';
import h25c from '../pages/Gallery/Image/Gallery8.webp';
import h25d from '../pages/Gallery/Image/Gallery9.webp';
import h25e from '../pages/Gallery/Image/Gallery10.webp';
import h25f from '../pages/Gallery/Image/Gallery11.webp';
// Full gallery.
import G1 from '../pages/Gallery/Image/G1.webp';
import G2 from '../pages/Gallery/Image/G2.webp';
import G3 from '../pages/Gallery/Image/G3.webp';
import G4 from '../pages/Gallery/Image/G4.webp';
import G5 from '../pages/Gallery/Image/G5.webp';
import G6 from '../pages/Gallery/Image/G6.webp';
import G7 from '../pages/Gallery/Image/G7.webp';
import G8 from '../pages/Gallery/Image/G8.webp';
import G9 from '../pages/Gallery/Image/G9.webp';
import G10 from '../pages/Gallery/Image/G10.webp';
import G11 from '../pages/Gallery/Image/G11.webp';
import G12 from '../pages/Gallery/Image/G12.webp';
import G13 from '../pages/Gallery/Image/G13.webp';
import S4_1 from '../pages/Gallery/Image/S4_01.webp';
import S4_2 from '../pages/Gallery/Image/S4_02.webp';
import S4_3 from '../pages/Gallery/Image/S4_03.webp';
import S4_4 from '../pages/Gallery/Image/S4_04.webp';
import S4_5 from '../pages/Gallery/Image/S4_05.webp';
import S4_6 from '../pages/Gallery/Image/S4_06.webp';
import S4_7 from '../pages/Gallery/Image/S4_07.webp';
import S4_8 from '../pages/Gallery/Image/S4_08.webp';
import S4_9 from '../pages/Gallery/Image/S4_09.webp';
import S4_10 from '../pages/Gallery/Image/S4_10.webp';
import S4_11 from '../pages/Gallery/Image/S4_11.webp';
import S4_12 from '../pages/Gallery/Image/S4_12.webp';
import S4_13 from '../pages/Gallery/Image/S4_13.webp';
import S4_14 from '../pages/Gallery/Image/S4_14.webp';
import S4_15 from '../pages/Gallery/Image/S4_15.webp';
import S4_16 from '../pages/Gallery/Image/S4_16.webp';
import S4_17 from '../pages/Gallery/Image/S4_17.webp';

// Keyed by season year; the newest year is shown first.
export const GALLERY_HIGHLIGHTS = {
  2025: [h25a, h25b, h25c, h25d, h25e, h25f],
  2024: [h24a, h24b, h24c, h24d, h24e, h24f],
};

export const GALLERY_ALL = {
  2025: [S4_1, S4_2, S4_3, S4_4, S4_5, S4_6, S4_7, S4_8, S4_9, S4_10, S4_11, S4_12, S4_13, S4_14, S4_15, S4_16, S4_17],
  2024: [G1, G2, G3, G4, G5, G6, G7, G8, G9, G10, G11, G12, G13],
};
